<template>
  <vh-dialog
    :title="$t('host.k_595062')"
    draggable
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    append-to-body
    top="10vh"
    width="1100px"
    @close="handleClose"
  >
    <div class="sign-list-panel">
      <vh-table :data="dataList" style="width: 100%" height="520px" v-loading="loading">
        <template slot="empty">
          <div class="table-empty">{{ $t('host.k_595077') }}</div>
        </template>
        <vh-table-column prop="push_time" :label="$t('host.k_595065')" width="180">
          <template slot-scope="{ row }">
            {{ row.push_time || '-' }}
          </template>
        </vh-table-column>
        <vh-table-column prop="push_status" :label="$t('host.k_595068')" width="100">
          <template slot-scope="{ row }">
            {{
              row.push_status == 1
                ? $t('host.k_595071')
                : row.push_status == 2
                ? $t('host.k_595081')
                : $t('host.k_595070')
            }}
          </template>
        </vh-table-column>
        <vh-table-column prop="push_type" :label="$t('host.k_595064')" width="100">
          <template slot-scope="{ row }">
            {{ row.push_type == 1 ? $t('host.k_595072') : $t('host.k_595073') }}
          </template>
        </vh-table-column>
        <vh-table-column
          prop="title"
          :label="$t('host.k_595063')"
          min-width="140"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            {{ row.title || '-' }}
          </template>
        </vh-table-column>
        <vh-table-column prop="show_time" :label="$t('host.k_595066')" width="120">
          <template slot-scope="{ row }">
            {{ formatSeconds(row.show_time || '-') }}
          </template>
        </vh-table-column>
        <vh-table-column
          prop="sign_in_success_tips"
          :label="$t('host.k_595067')"
          min-width="120"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            {{ row.sign_in_success_tips || '-' }}
          </template>
        </vh-table-column>
        <vh-table-column prop="count" :label="$t('host.k_595074')" width="90" />
        <vh-table-column fixed="right" align="center" :label="$t('host.k_595069')" width="140">
          <template slot-scope="{ row }">
            <!-- push_status 0-未推送 1-已推送 2 推送中 -->
            <vh-button
              v-if="row.push_status == 0"
              size="mini"
              type="text"
              style="margin-left: 50%; transform: translateX(-50%)"
              @click="handleDelete(row)"
            >
              {{ $t('host.k_595078') }}
            </vh-button>
            <vh-button
              v-if="row.push_status == 2 && row.sign_time_ttl > 0 && restOfTime > 0"
              size="mini"
              type="text"
              :disabled="row.show_time - restOfTime < 10"
              @click="handleOver(row)"
            >
              {{ $t('host.k_595079') + '(' + restOfTime + 's)' }}
            </vh-button>
          </template>
        </vh-table-column>
      </vh-table>
      <!-- 分页 -->
      <div class="m-t-16 text-center">
        <vh-pagination
          v-if="total > 0"
          background
          layout="prev, pager, next, total"
          :page-size="limit"
          :total="total"
          :current-page="pageNum"
          @current-change="handlePageChange"
          hide-on-single-page
        ></vh-pagination>
      </div>
    </div>
  </vh-dialog>
</template>
<script>
  import { to } from 'await-to-js';
  import { useSignServer } from 'middle-domain';

  export default {
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      // 为了保证计时一致性，统一使用外层同一个计时器
      // 当前正在进行中的签到id
      signId: {
        type: [Number, String],
        default: undefined
      },
      // 剩余时间
      remaining: {
        type: Number,
        default: 0
      },
      // 是否复用props传过来的remaining
      reuse: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        loading: false,
        pageNum: 1,
        limit: 10,
        total: 0,
        dataList: [],
        timer: 0,
        count: 0,
        signTimeTtl: 0
      };
    },
    computed: {
      dialogVisible: {
        get() {
          return this.visible;
        },
        set(val) {
          this.$emit('update:visible', val);
        }
      },
      roomId() {
        return this.$domainStore?.state?.roomBaseServer?.watchInitData?.interact?.room_id || '';
      },
      doingSign() {
        return this.dataList.find(item => item.push_status === 2);
      },
      isReuseRemainingTime() {
        return this.reuse && this.signId && this.signId == this.doingSign?.id;
      },
      // 剩余时间
      restOfTime() {
        return this.isReuseRemainingTime ? this.remaining : this.signTimeTtl;
      }
    },
    watch: {
      visible(val) {
        if (val) {
          this.pageNum = 1;
          this.getSignStatList();
        }
      }
    },
    beforeCreate() {
      this.signServer = useSignServer();
    },
    beforeDestroy() {
      this.removeTimer();
    },
    methods: {
      formatSeconds(seconds) {
        if (typeof seconds !== 'number') return '-';
        // 计算小时、分钟和剩余的秒数
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;

        // 将各部分格式化为两位数
        const formatHour = hours.toString().padStart(2, '0');
        const formatMin = minutes.toString().padStart(2, '0');
        const formatSec = secs.toString().padStart(2, '0');

        // 如果有小时部分，返回 hh:mm:ss 格式
        if (hours > 0) {
          return `${formatHour}:${formatMin}:${formatSec}`;
        }
        // 否则返回 mm:ss 格式
        return `${formatMin}:${formatSec}`;
      },
      // 获取列表
      async getSignStatList() {
        this.loading = true;
        const params = {
          sort_fields: JSON.stringify([{ field: 'push_time', type: 'desc' }]),
          room_id: this.roomId,
          push_type: 1, // 这里固定为定时推送
          pos: (this.pageNum - 1) * this.limit,
          limit: this.limit
        };
        const [err, res] = await to(this.signServer.getSignStatList(params));
        this.loading = false;
        if (err || !res || res.code != 200 || !res.data) {
          this.$message.error(err?.msg || res?.msg || '请求失败');
          return;
        }
        this.total = res.data.total || 0;
        this.dataList = res.data.list || [];
        this.checkSignAndCountdown();
      },
      removeTimer() {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      },
      // 检查签到是否进行中并启动倒计时
      checkSignAndCountdown() {
        if (this.doingSign && !this.isReuseRemainingTime) {
          this.signTimeTtl = this.doingSign.sign_time_ttl;
          this.removeTimer();
          this.timer = setInterval(() => {
            if (this.signTimeTtl > 0) {
              this.signTimeTtl--;
            }
          }, 1000);
        }
      },
      handlePageChange(page) {
        this.pageNum = page;
        this.getSignStatList();
      },
      handleClose() {
        this.dataList = [];
        this.total = 0;
        this.pageNum = 1;
      },
      // 删除签到
      async handleDelete(row) {
        const [cancel, confirm] = await to(
          this.$vhConfirm(this.$t('host.k_595080'), this.$t('host.k_597004'), {
            confirmButtonText: this.$t('host.k_597005'),
            cancelButtonText: this.$t('host.k_597006'),
            roundButton: true
          })
        );
        if (cancel || !confirm) return;
        const params = {
          room_id: this.roomId,
          sign_ids: row.id
        };
        const [err, res] = await to(this.signServer.delSign(params));
        if (err || !res || res.code != 200 || !res.data) {
          this.$message.error(err?.msg || res?.msg || '请求失败');
          return;
        }
        this.$message.success(`${this.$t('host.k_597007')}`);
        this.getSignStatList();
      },
      // 结束签到
      async handleOver(row) {
        const [cancel, confirm] = await to(
          this.$vhConfirm(this.$t('host.k_595080'), this.$t('host.k_597004'), {
            confirmButtonText: this.$t('host.k_597005'),
            cancelButtonText: this.$t('host.k_597006'),
            roundButton: true
          })
        );
        if (cancel || !confirm) return;
        const params = {
          room_id: this.roomId,
          sign_id: row.id
        };
        const [err, res] = await to(this.signServer.signClose(params));
        if (err || !res || res.code != 200 || !res.data) {
          this.$message.error(err?.msg || res?.msg || '请求失败');
          return;
        }
        this.getSignStatList();
      }
    }
  };
</script>
<style lang="less" scoped>
  .sign-list-panel {
    padding: 0 8px;
  }
  .table-empty {
    padding: 40px 0;
    color: #999;
    font-size: 14px;
  }
  .text-center {
    text-align: center;
  }
  .m-t-16 {
    margin-top: 16px;
  }
</style>
